import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './init';
import './app/lib/materialize';

import React        from 'react';
import ReactDOM     from 'react-dom';
//import Perf         from 'react-addons-perf';

import 'app/globals';
import RootComponent    from 'routes/RootComponent';
import { createRoutes } from 'routes';


ReactDOM.render(
  <RootComponent createRoutes={createRoutes} />,
  window.document.getElementById('app')
);
